document.addEventListener('DOMContentLoaded', function() {
  const grandchildLinks = document.querySelectorAll('.mega-menu__content .mega-menu__list ul li a[data-image]');
  const imageContainer = document.querySelector('.mega-menu__image-container img');
  const defaultImage = 'https://via.placeholder.com/300';

  grandchildLinks.forEach(link => {
    link.addEventListener('mouseover', function() {
      const imageUrl = link.getAttribute('data-image') || defaultImage;
      imageContainer.src = imageUrl;
      imageContainer.style.opacity = '1';
      imageContainer.parentElement.style.display = 'block';
    });

    link.addEventListener('mouseout', function() {
      imageContainer.style.opacity = '0';
      imageContainer.parentElement.style.display = 'none';
    });
  });
});
